/**
 * Regular expression for basic email validation.
 */
export const validateEmailPattern = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

/**
 * Validates the email field and returns an error string if invalid, or null if valid.
 */
export const validateEmailField = (email: string): string | null => {
    if (!email) return 'Email is required';
    if (!validateEmailPattern(email)) return 'Please enter a valid email address';
    return null;
};

/**
 * Validates the login identifier (email or username) field.
 */
export const validateLoginIdentifier = (identifier: string): string | null => {
    if (!identifier) return 'Email or username is required';
    if (identifier.length <= 3) return 'Must be longer than 3 characters';
    return null;
};

/**
 * Validates the username field and returns an error string if invalid, or null if valid.
 */
export const validateUsernameField = (username: string): string | null => {
    if (!username) return 'Username is required';
    if (username.includes('@')) return 'Username cannot contain the @ symbol';
    return null;
};

/**
 * Validates the password field and returns an error string if invalid, or null if valid.
 */
export const validatePasswordField = (password: string): string | null => {
    if (!password) return 'Password is required';
    if (password.length < 8) return 'Minimum character length is 8';
    return null;
};

/**
 * Validates the confirm password field against the original password.
 */
export const validateConfirmPassword = (password: string, confirm: string): string | null => {
    if (!confirm) return 'Please confirm your password';
    if (password !== confirm) return 'Passwords do not match';
    return null;
};
